var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "booking-history 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.7748 10.1272H24.471C25.697 10.1272 26.6911 9.13317 26.6911 7.90694V7.89979C26.6911 6.67374 25.697 5.67969 24.471 5.67969H17.7748C16.5485 5.67969 15.5547 6.67374 15.5547 7.89979V7.90694C15.5547 9.13317 16.5485 10.1272 17.7748 10.1272Z",
    fill: "url(#paint0_linear_359_4456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.6296 30.1557H19.3911C19.6189 28.5381 20.1886 27.0304 21.0254 25.7082H15.6296C15.0149 25.7082 14.5166 25.2022 14.5166 24.5875C14.5166 23.9728 15.0149 23.4667 15.6296 23.4667H22.8868C24.9058 21.588 27.6123 20.4383 30.5878 20.4383C31.9577 20.4383 33.2707 20.682 34.4859 21.1283V11.2799C34.4859 9.43592 33.0564 7.88281 31.2122 7.88281H28.9355V7.94685C28.9355 10.3984 26.9916 12.3303 24.5399 12.3303H17.8497C15.3981 12.3303 13.3516 10.3985 13.3516 7.94685V7.88281H11.1774C9.33331 7.88281 7.76562 9.43574 7.76562 11.2799V33.5408C7.76562 35.385 9.33326 36.809 11.1774 36.809H20.4734C19.7962 35.4586 19.3812 33.9541 19.2959 32.3617H15.6296C15.0149 32.3617 14.5166 31.8734 14.5166 31.2587C14.5166 30.6439 15.0149 30.1557 15.6296 30.1557ZM15.6296 16.7778H26.76C27.3748 16.7778 27.873 17.2838 27.873 17.8985C27.873 18.5132 27.3748 19.0193 26.76 19.0193H15.6296C15.0149 19.0193 14.5166 18.5132 14.5166 17.8985C14.5166 17.2838 15.0149 16.7778 15.6296 16.7778Z",
    fill: "url(#paint1_linear_359_4456)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.5232 22.7422C25.5873 22.7422 21.5859 26.7435 21.5859 31.6795C21.5859 36.6153 25.5873 40.6167 30.5232 40.6167C35.4591 40.6167 39.4604 36.6153 39.4604 31.6795C39.4604 26.7435 35.459 22.7422 30.5232 22.7422ZM34.08 35.2339C33.6437 35.6701 32.9344 35.6682 32.5033 35.2371L29.771 32.5048C29.6836 32.4249 29.6089 32.3313 29.5502 32.2274C29.4539 32.0576 29.4057 31.868 29.4061 31.6782V31.6762V26.0969C29.4061 25.4781 29.9019 24.9765 30.5233 24.9765C31.1402 24.9765 31.6404 25.4775 31.6404 26.0969V31.2144L34.0832 33.6571C34.5177 34.0917 34.5193 34.7946 34.08 35.2339Z",
    fill: "url(#paint2_linear_359_4456)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_359_4456",
    x1: 21.1229,
    y1: 5.67969,
    x2: 21.1229,
    y2: 10.1272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF656C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_359_4456",
    x1: 8,
    y1: 21,
    x2: 37,
    y2: 24.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF656C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_359_4456",
    x1: 21.5859,
    y1: 29.9384,
    x2: 39.4604,
    y2: 33.4204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF727D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF646B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingHistory);
export default __webpack_public_path__ + "static/media/booking-history .2b6570b12997be83d50d9215186039b0.svg";
export { ForwardRef as ReactComponent };